<script>
export let name = 'Section';
</script>

<h3 class="text-gray-500 mt-8">{name}</h3>
<hr>